// A provider retry is Phoebe's own housekeeping: the step line already
// names the work in progress, so the retry draws nothing.
import { z } from 'zod';

import { defineInvisible } from '@apps/web/features/phoebe_chat_v3/registry/types';

const payloadSchema = z.object({
    type: z.literal('run_provider_retrying'),
    error_recoverability: z.literal('recoverable'),
    error_type: z.string(),
    error_message: z.string(),
    provider_status_code: z.number().int(),
    attempt: z.number().int(),
    max_attempts: z.number().int(),
    retry_at: z.iso.datetime({ offset: true }),
});

export const runProviderRetryingDefinitions = {
    run_provider_retrying: defineInvisible('run_provider_retrying', {
        disposition: 'invisible',
        schema: payloadSchema,
        malformed: { kind: 'skip' },
        evidence: null,
    }),
} as const;

export const runProviderRetryingContractFixtures = {
    valid: {
        type: 'run_provider_retrying',
        error_recoverability: 'recoverable',
        error_type: 'provider-internal-sentinel',
        error_message: 'provider-error-sentinel',
        error_cause: 'provider-cause-sentinel',
        provider_status_code: 529,
        attempt: 1,
        max_attempts: 3,
        retry_at: '2026-08-28T12:00:00Z',
    },
    malformed: {
        type: 'run_provider_retrying',
        error_recoverability: 'recoverable',
        error_type: 'provider-internal-sentinel',
        error_message: 'provider-error-sentinel',
        provider_status_code: '529',
        attempt: 1,
        max_attempts: 3,
        retry_at: '2026-08-28T12:00:00Z',
    },
} as const;
